var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes + _vm.classObj,staticStyle:{"z-index":"200"}},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+" , All rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }